import Button from "@/components/bricks/button/Button";
import { useQuery } from "@tanstack/react-query";
import { ReactNode, useState } from "react";
import { defaultApiUrl, get, openReportWithAuth } from "../../../api/util";
import DownloadIcon from "../../icons/DownloadIcon";
import Modal, { ModalRoot, ModalTrigger } from "../Modal";
import Spinner from "../../spinner/Spinner";

interface IDocumentModalProps {
  title: ReactNode;
  description?: string;
  getDocument: string;
  downloadLink?: string;
  buttonContents: ReactNode;
  contentProps?: DivProps;
  disabled?: boolean;
}
export default function DocumentModal(props: IDocumentModalProps) {
  const {
    title,
    description,
    getDocument,
    buttonContents,
    contentProps,
    downloadLink,
    disabled,
  } = props;
  const [open, setOpen] = useState(false);

  const handleDownloadClick = async () => {
    if (!downloadLink) return;
    try {
      await openReportWithAuth(`${defaultApiUrl}${downloadLink}`);
    } catch (e) {
      console.error(e);
    }
  };

  return (
    <ModalRoot
      controller={{
        open: open,
        setOpen: setOpen,
      }}
    >
      <ModalTrigger asChild>
        <Button
          disabled={disabled}
          color="secondary"
          onClick={() => {}}
          size="sm"
        >
          {buttonContents}
        </Button>
      </ModalTrigger>
      <Modal
        title={
          <>
            {title}
            {downloadLink && (
              <div style={{ marginLeft: "auto" }}>
                <Button
                  color="-action"
                  type="button"
                  onClick={() => void handleDownloadClick()}
                >
                  <DownloadIcon /> Hent
                </Button>
              </div>
            )}
          </>
        }
        description={description}
      >
        <div className="c-modal-container">
          <div className="c-modal-container-inner c-modal-container-inner--md">
            {open && <Content getDocument={getDocument} {...contentProps} />}
          </div>
        </div>
      </Modal>
    </ModalRoot>
  );
}

interface ContentProps extends DivProps {
  getDocument: string;
}
function Content(props: ContentProps) {
  const { getDocument, ...rest } = props;

  const { data, isLoading, error } = useQuery({
    queryKey: ["getDocument", getDocument],
    queryFn: async function () {
      return get<string>({ query: getDocument });
    },
  });
  if (isLoading) {
    return <Spinner />;
  }
  if (error) {
    return <div>Noget gik galt</div>;
  }
  if (!data) {
    return <div>Dokument mangler</div>;
  }
  return (
    <div
      className="container"
      // style={{ whiteSpace: "pre-wrap" }}
      dangerouslySetInnerHTML={{
        // __html: data.replaceAll(/style="[a-zA-Z0-9:;\.\s\(\)\-\,]*"/gm, ""),
        __html: data,
      }}
      {...rest}
    ></div>
  );
}
